var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerificateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.119,
    height: 43.691,
    viewBox: "0 0 58.119 43.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    transform: "translate(-1650.94 -237.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M29.043,43.688q-11.587,0-23.174-.005A5.586,5.586,0,0,1,0,37.968Q.01,21.84.006,5.713A5.54,5.54,0,0,1,5.581,0c.2-.006.393,0,.59,0q23,0,45.994,0a5.651,5.651,0,0,1,5.17,2.713A5.025,5.025,0,0,1,58.113,5.4q.006,16.452,0,32.9a5.542,5.542,0,0,1-5.834,5.387q-11.616.011-23.233,0M29,39.869c7.725,0,15.45-.026,23.174.02A2.01,2.01,0,0,0,54.4,37.651q-.033-15.8,0-31.607A2.013,2.013,0,0,0,52.179,3.8q-23.115.05-46.231.02c-1.58,0-2.209.63-2.209,2.217q0,15.8,0,31.607c0,1.591.628,2.223,2.2,2.224H29",
    transform: "translate(1650.94 237.044)",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M233.127,64.972a5.586,5.586,0,0,1-.863,3.376,3.332,3.332,0,0,0-.411,2.509c.4,3.053.773,6.111,1.156,9.167.039.311.084.622.113.935a1.853,1.853,0,0,1-.935,1.947,1.9,1.9,0,0,1-2.154-.192c-1.2-.818-2.431-1.6-3.623-2.432a.867.867,0,0,0-1.156.006c-1.193.832-2.42,1.614-3.624,2.43a1.9,1.9,0,0,1-2.155.182,1.829,1.829,0,0,1-.926-1.951c.2-1.754.427-3.506.646-5.258q.373-2.979.757-5.956a1.279,1.279,0,0,0-.269-.875,7.293,7.293,0,1,1,13.445-3.889m-7.3-3.521a3.52,3.52,0,1,0,3.569,3.533,3.516,3.516,0,0,0-3.569-3.533m2.99,15.317c-.191-1.474-.4-2.988-.577-4.5-.037-.312-.174-.358-.425-.281a6.489,6.489,0,0,1-3.934,0c-.3-.093-.426-.01-.447.317-.026.409-.108.815-.159,1.222-.139,1.107-.277,2.215-.406,3.323-.014.123-.079.307.094.358.086.025.218-.057.311-.117.428-.277.858-.553,1.274-.848a2.043,2.043,0,0,1,2.563-.015c.418.292.845.571,1.274.848.108.07.22.219.363.122s.054-.253.07-.426",
    transform: "translate(1466.849 188.486)",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M67.681,149.6c2.673,0,5.346-.011,8.018,0a1.877,1.877,0,0,1,1.716,2.843,1.723,1.723,0,0,1-1.325.878,9.509,9.509,0,0,1-1.116.069q-7.311.007-14.621,0a8.853,8.853,0,0,1-1-.056,1.812,1.812,0,0,1-1.7-2.009,1.845,1.845,0,0,1,1.894-1.724c2.26-.016,4.52-.006,6.78-.006h1.356",
    transform: "translate(1602.376 111.02)",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M67.639,57.565c2.652,0,5.305-.009,7.958,0A1.873,1.873,0,0,1,77.61,59.6,1.809,1.809,0,0,1,76.2,61.277a4.122,4.122,0,0,1-.934.1q-7.663.009-15.326.006a3.226,3.226,0,0,1-1.1-.15,1.874,1.874,0,0,1-1.223-2.109,1.915,1.915,0,0,1,1.952-1.55c2.515-.014,5.03-.006,7.545-.006h.531",
    transform: "translate(1602.429 188.553)",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M67.628,199.255c-2.653,0-5.305.009-7.958,0a1.878,1.878,0,0,1-2.016-2.031,1.832,1.832,0,0,1,1.356-1.667A3.53,3.53,0,0,1,60,195.44q7.663,0,15.326,0a3.95,3.95,0,0,1,.7.051,1.848,1.848,0,0,1,1.631,2.087,1.871,1.871,0,0,1-1.9,1.665c-1.159.026-2.319.008-3.478.008H67.628",
    transform: "translate(1602.374 72.404)",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M64.95,107.291c-1.748,0-3.5,0-5.244,0a1.874,1.874,0,0,1-2.055-1.742,1.8,1.8,0,0,1,1.832-2c1.016-.072,2.04-.047,3.061-.049q3.505-.009,7.011,0a8.516,8.516,0,0,1,1,.058,1.808,1.808,0,0,1,1.681,1.971,1.851,1.851,0,0,1-1.864,1.759c-1.807.02-3.614.006-5.42.006Z",
    transform: "translate(1602.376 149.862)",
    fill: "#fb0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerificateIcon);
export default __webpack_public_path__ + "static/media/cerificate_icon.17a520a495958629cd03f724fdc201ae.svg";
export { ForwardRef as ReactComponent };